// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8f9b0e9e","453":"aecef830"}[chunkId] + ".chunk.js";
};